
export const ListMode = ({ item }) => {
    return (
        <div className="row p-project-list-mode">
            <div className="col-1 d-flex justify-content-center align-items-start">
                <i className="bi bi-folder2"
                    style={{ color: '#8E24AA', fontSize: '20px', marginTop: '0px' }}>
                </i>
            </div>
            <div className="col text-start">
                <div className="text-[16px] text-[#595759] lowercase first-letter:uppercase font-semibold">{item.nombre}</div>
                <div className='capitalize'>{item.cliente}</div>
                <div className='mt-3 capitalize'>{item.total_tareas_completadas} / {item.total_tareas} tareas</div>
                <div className="mt-1 d-flex justify-content-between align-items-center">
                    <progress className="p-progress" max="100" value={item?.progreso} />
                    <span className="ms-2" style={{ color: '#3CB43A', fontWeight: 'bold' }}>{item?.progreso || 0}%</span>
                </div>

            </div>
        </div>
    )
}